import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=190fc2b7&"
import script from "./ContextMenu.vue?vue&type=script&lang=ts&"
export * from "./ContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports